import { useState } from "react";
import NxtbnModal from "../../Modal";
import SelectStyled from "../../Select";
import { InputField } from "../../common";
import useApi from "../../../api";
import { toast } from "react-toastify";
import countryList from "react-select-country-list";
import enumChoice from "../../../enum";

interface Props {
  edit?:any;
  isOpen: boolean;
  onClose: ()=>void;
  shippingMethodId?: number;
  refresh: ()=>void;
}

function ShippingRateForm({ edit, isOpen, onClose, shippingMethodId, refresh }:Props) {
  
  const [formData, setFormData] = useState<any>(edit ? { shipping_method: shippingMethodId, ...edit } : { shipping_method: shippingMethodId })
  const [errorData, setErrorData] = useState<any>()
  const api = useApi()

  const country = countryList().getData()

  const onSelectHandler = (e:any, name:any) => {
    setFormData((prev:any)=> ({...prev, [name]: e.value}))
  }

  const onChangeHandler = (e:any) => {
    const {name, value} = e.target 
    setFormData((prev:any)=>({...prev, [name]: value}))
  }

  const onSubmit = (e:any, id?:number) => {
    e.preventDefault()
    if (!edit) { 
      api.createShippingRate(formData).then((response:any)=>{
        toast.success('Shipping rate created')
        refresh()
        setFormData({})
        onClose()
      }, (error)=>setErrorData(error.response.data))
    } else {
      api.updateShippingRate(id, formData).then((response:any)=>{
        toast.success('Successfully Shipping Rate updated .')
        refresh()
        setFormData({})
        onClose()
      }, (error)=>setErrorData(error.response.data))
    }
  }
  return (
    <NxtbnModal
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
    >
      <div className="p-4">
        <div className="flex flex-col">
          <div className="flex flex-col gap-2 w-full">
            <div className="w-full flex  flex-col md:flex-row gap-3">
              <div className="flex flex-col w-full pt-6">
                <label htmlFor="country" className="text-sm text-base-300 mb-4">
                  Country
                </label>
                <div>
                  <SelectStyled
                    name="country"
                    options={country}
                    defaultValue={country.find(
                      (item) => item.value === formData.country
                    )}
                    onChange={(e) => onSelectHandler(e, "country")}
                    errorData={errorData}
                  />
                </div>
              </div>
              <div className="flex flex-col w-full pt-6">
                <label htmlFor="region" className="text-sm text-base-300">
                  Region
                </label>
                <div>
                  <InputField
                    id="region"
                    type="text"
                    name="region"
                    value={formData?.region || ""}
                    onChange={onChangeHandler}
                    placeholder="Region"
                    className="w-full px-5 py-3 bg-secondary-50 mt-3 rounded-md font-nunito outline-[#0CAF60] border-[2px] border-dashed"
                    errorData={errorData}
                  />
                </div>
              </div>
            </div>
            <div className="w-full flex flex-col md:flex-row gap-3">
              <div className="flex flex-col w-full pt-6">
                <label htmlFor="city" className="text-sm text-base-300">
                  City
                </label>
                <div>
                  <InputField
                    id="city"
                    type="text"
                    name="city"
                    value={formData?.city || ""}
                    onChange={onChangeHandler}
                    placeholder="City"
                    className="w-full px-5 py-3 bg-secondary-50 mt-3 rounded-md font-nunito outline-[#0CAF60] border-[2px] border-dashed"
                    errorData={errorData}
                  />
                </div>
              </div>

              <div className="flex flex-col w-full pt-6">
                <label htmlFor="weight_min" className="text-sm text-base-300">
                  Minimum Weight
                </label>
                <div>
                  <InputField
                    id="weight_min"
                    type="number"
                    name="weight_min"
                    value={formData?.weight_min || ""}
                    onChange={onChangeHandler}
                    placeholder="0.00"
                    className="w-full px-5 py-3 bg-secondary-50 mt-3 rounded-md font-nunito outline-[#0CAF60] border-[2px] border-dashed"
                    errorData={errorData}
                  />
                </div>
              </div>
            </div>

            <div className="w-full flex flex-col md:flex-row gap-3">
              <div className="flex flex-col w-full pt-6">
                <label htmlFor="weight_max" className="text-sm text-base-300">
                  Maximum Weight
                </label>
                <div>
                  <InputField
                    id="weight_max"
                    type="number"
                    name="weight_max"
                    value={formData?.weight_max || ""}
                    onChange={onChangeHandler}
                    placeholder="0.00"
                    className="w-full px-5 py-3 bg-secondary-50 mt-3 rounded-md font-nunito outline-[#0CAF60] border-[2px] border-dashed"
                    errorData={errorData}
                  />
                </div>
              </div>
              <div className="flex flex-col w-full pt-6">
                <label htmlFor="rate" className="text-sm text-base-300">
                  Rate
                </label>
                <div>
                  <InputField
                    id="rate"
                    type="number"
                    name="rate"
                    value={formData?.rate || ""}
                    onChange={onChangeHandler}
                    placeholder="0.00"
                    className="w-full px-5 py-3 bg-secondary-50 mt-3 rounded-md font-nunito outline-[#0CAF60] border-[2px] border-dashed"
                    errorData={errorData}
                  />
                </div>
              </div>
            </div>
            <div className="w-full flex flex-col md:flex-row gap-3">
              <div className="flex flex-col w-full pt-6">
                <label
                  htmlFor="currency"
                  className="text-sm text-base-300 mb-4"
                >
                  Currency
                </label>
                <div>
                  <SelectStyled
                    name="currency"
                    options={enumChoice.currency}
                    defaultValue={enumChoice.currency.find(
                      (item) => item.value === formData?.currency
                    )}
                    onChange={(e) => onSelectHandler(e, "currency")}
                    errorData={errorData}
                  />
                </div>
              </div>
              <div className="flex flex-col w-full pt-6">
                <label
                  htmlFor="incremental_rate"
                  className="text-sm text-base-300"
                >
                  Incremental Rate
                </label>
                <div>
                  <InputField
                    id="incremental_rate"
                    type="number"
                    name="incremental_rate"
                    value={formData?.incremental_rate || ""}
                    onChange={onChangeHandler}
                    placeholder="0.00"
                    className="w-full px-5 py-3 bg-secondary-50 mt-3 rounded-md font-nunito outline-[#0CAF60] border-[2px] border-dashed"
                    errorData={errorData}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-6 mb-6 flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="mr-3 inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-gray-600 text-base font-medium text-white shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-primary-600 text-base font-medium text-white shadow-sm hover:bg-primary-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
            onClick={(e: any) =>
              edit ? onSubmit(e, formData.id) : onSubmit(e)
            }
          >
            {edit ? "Update" : "Add"}
          </button>
        </div>
      </div>
    </NxtbnModal>
  );
}

export default ShippingRateForm;
